import { Controller } from 'stimulus'

export default class extends Controller {
  onLoad(event) {
    this.injectStyles(event.detail.iframe)
  }

  injectStyles(iframe) {
    const styles = getComputedStyle(iframe)
    const newStyleElement = document.createElement('style')

    const variablesToCopy = [
      '--color-background',
      '--color-headline',
      '--color-subheadline',
      '--color-preheadline',
      '--color-paragraph',
      '--color-link',
      '--color-input-accent',
      '--color-input-text',
      '--color-input-label',
      '--color-input-border',
      '--color-input-background',
      '--sg-button-background-color',
      '--sg-button-background-image',
      '--sg-button-border-color',
      '--sg-button-border-radius-tl',
      '--sg-button-border-radius-tr',
      '--sg-button-border-radius-br',
      '--sg-button-border-radius-bl',
      '--sg-button-border-style',
      '--sg-button-border-top-width',
      '--sg-button-border-right-width',
      '--sg-button-border-bottom-width',
      '--sg-button-border-left-width',
      '--sg-button-box-shadow',
      '--sg-button-text-color',
      '--sg-button-text-font-family',
      '--sg-button-text-font-size',
      '--sg-button-text-font-weight',
      '--sg-button-text-letter-spacing',
      '--sg-button-text-line-height',
      '--sg-button-padding-top',
      '--sg-button-padding-right',
      '--sg-button-padding-bottom',
      '--sg-button-padding-left',
    ]

    const css = variablesToCopy.map(
      (v) => `${v}: ${styles.getPropertyValue(v)}`
    )

    newStyleElement.textContent = `
        :root { ${css.join(';')} }
      `

    if (iframe.contentDocument) {
      iframe.contentDocument.head.appendChild(newStyleElement)
    }
  }
}
